// src/features/promoteur/useSubscription.js
import { db } from "@/Firebase";
import { doc, getDoc } from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";

export function useSubscription(userId) {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [expiryDate, setExpiryDate]     = useState(null);
  const [daysLeft, setDaysLeft]         = useState(0);
  const [loading, setLoading]           = useState(true);

  const fetchSubscription = useCallback(async () => {
    if (!userId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const subDoc = await getDoc(doc(db, "chargilySubscriptions", userId));

      if (subDoc.exists()) {
        const data   = subDoc.data();
        const expiry = data.subscribed_until?.toDate?.() || null;
        const active = data.is_subscribed === true && expiry && expiry > new Date();

        setIsSubscribed(active);
        setExpiryDate(expiry);

        if (active && expiry) {
          const diff = Math.ceil((expiry - new Date()) / (1000 * 60 * 60 * 24));
          setDaysLeft(diff);
        } else {
          setDaysLeft(0);
        }
      } else {
        setIsSubscribed(false);
        setExpiryDate(null);
        setDaysLeft(0);
      }
    } catch (error) {
      console.error("❌ useSubscription:", error);
      setIsSubscribed(false);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchSubscription();
  }, [fetchSubscription]);

  return {
    isSubscribed,
    expiryDate,
    daysLeft,
    loading,
    refetch: fetchSubscription, // ✅ exposé pour le polling
  };
}